/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_TitleInputs */

const tr_landing_shortcuts_title = /** @type {(inputs: Landing_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çok hızlı. Her şey için`)
};

const en_landing_shortcuts_title = /** @type {(inputs: Landing_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blazing fast. One shortcut`)
};

const de_landing_shortcuts_title = /** @type {(inputs: Landing_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blitzschnell. Für alles`)
};

const ru_landing_shortcuts_title = /** @type {(inputs: Landing_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Молниеносно. Для всего`)
};

/**
* | output |
* | --- |
* | "Blazing fast. One shortcut" |
*
* @param {Landing_Shortcuts_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_title = /** @type {((inputs?: Landing_Shortcuts_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_title(inputs)
	if (locale === "de") return de_landing_shortcuts_title(inputs)
	if (locale === "ru") return ru_landing_shortcuts_title(inputs)
	return tr_landing_shortcuts_title(inputs)
});